import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTaurus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.0001 14.6667C13.9499 14.6667 10.6667 17.9499 10.6667 22C10.6667 26.0501 13.9499 29.3333 18.0001 29.3333C22.0501 29.3333 25.3333 26.0501 25.3333 22C25.3333 17.9499 22.0501 14.6667 18.0001 14.6667ZM18.0001 14.6667C15.9557 14.6667 13.9881 13.616 12.515 10.5438C10.3012 5.9264 7.33331 6.71828 7.33331 6.71828M18.0001 14.6667C20.0445 14.6667 22.0118 13.616 23.485 10.5438C25.6988 5.92644 28.6667 6.71832 28.6667 6.71832",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTaurus;
